import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './HomePage';
import WorkPage from './WorkPage';
import AboutPage from './AboutPage';
import ServicesPage from './ServicesPage';
import HousePage from './HousePage';
import DispatchPage from './DispatchPage';
import ContactPage from './ContactPage';
// MembersPage removed
import FAQPage from './FAQPage';
import EventsRoadmap from './EventsRoadmap';
// OpportunitiesPage removed
import ProtectedRoute from './ProtectedRoute';
// InfoPage removed
import TestComponent from './TestComponent';
import FounderPage from './FounderPage';
import LogoPage from './LogoPage';
import BlackCircleFavicon from './BlackCircleFavicon';
import NOPRBLMDeckPage from './NOPRBLMDeckPage';

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/work" element={<WorkPage />} />
      <Route path="/archive" element={<Navigate to="/work" />} />
      <Route path="/house" element={<HousePage />} />
      <Route path="/the-house" element={<Navigate to="/house" />} />
      <Route path="/innovation-studio" element={<Navigate to="/house" />} />
      <Route path="/about" element={<Navigate to="/house" />} />
      <Route path="/services" element={<Navigate to="/house" />} />
      {/* Opportunities routes removed */}
      <Route path="/dispatch" element={
        <ProtectedRoute passwordKey="dispatch">
          <DispatchPage />
        </ProtectedRoute>
      } />
      <Route path="/the-dispatch" element={<Navigate to="/dispatch" />} />
      <Route path="/contact" element={<Navigate to="/" />} />
      {/* Contact route redirects to home */}
      <Route path="/faq" element={<FAQPage />} />
      {/* Info page route removed */}
      <Route path="/test" element={<TestComponent />} />
      <Route path="/events-roadmap" element={
        <ProtectedRoute passwordKey="events-roadmap">
          <EventsRoadmap />
        </ProtectedRoute>
      } />
      <Route path="/the-events-roadmap" element={<Navigate to="/events-roadmap" />} />
      <Route path="/founder" element={<FounderPage />} />
      <Route path="/clare" element={<Navigate to="/founder" />} />
      <Route path="/logo-assets" element={<LogoPage />} />
      <Route path="/favicon" element={<BlackCircleFavicon />} />
      <Route path="/xxvinoprblmdeck" element={
        <ProtectedRoute passwordKey="xxvinoprblmdeck">
          <NOPRBLMDeckPage />
        </ProtectedRoute>
      } />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default AppRouter;